/* =========================================================================
   SAMSARA — SECTION-HOME-ORIGINS.JS
   Sprint 2.5 v2 — Carousel scroll-snap navigation (prev/next + a11y).

   Comportament:
     - Click prev/next → scrollBy(±slideWidth) cu smooth behavior
     - Update disabled state pe baza scrollLeft + scrollWidth - clientWidth
     - Update on scroll (debounced) + on resize
     - Keyboard: ArrowLeft/Right pe track focused
     - Multiple instances safe (querySelectorAll iteration)

   Vanilla, no deps. CLAUDE.md JS conventions §3.
   ========================================================================= */

(() => {
  const SCROLL_TOLERANCE = 4; // px slack pentru floor/ceil în calcule scrollLeft

  function debounce(fn, wait) {
    let t;
    return function debounced(...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function getSlideStep(track) {
    const slide = track.querySelector('[data-origins-slide]');
    if (!slide) return track.clientWidth;
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function updateButtons(track, prevBtn, nextBtn) {
    const max = track.scrollWidth - track.clientWidth;
    const x = track.scrollLeft;
    const atStart = x <= SCROLL_TOLERANCE;
    const atEnd = x >= max - SCROLL_TOLERANCE;
    if (prevBtn) prevBtn.disabled = atStart;
    if (nextBtn) nextBtn.disabled = atEnd;
  }

  function init(carousel) {
    const track = carousel.querySelector('[data-origins-track]');
    const prevBtn = carousel.querySelector('[data-origins-prev]');
    const nextBtn = carousel.querySelector('[data-origins-next]');
    if (!track) return;

    const sync = () => updateButtons(track, prevBtn, nextBtn);

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        track.scrollLeft = Math.max(0, track.scrollLeft - getSlideStep(track));
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const max = track.scrollWidth - track.clientWidth;
        track.scrollLeft = Math.min(max, track.scrollLeft + getSlideStep(track));
      });
    }

    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        const max = track.scrollWidth - track.clientWidth;
        track.scrollLeft = Math.min(max, track.scrollLeft + getSlideStep(track));
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        track.scrollLeft = Math.max(0, track.scrollLeft - getSlideStep(track));
      }
    });

    track.addEventListener('scroll', debounce(sync, 80), { passive: true });
    window.addEventListener('resize', debounce(sync, 120));

    // Initial sync (după layout settled)
    requestAnimationFrame(sync);
  }

  function bootstrap() {
    document.querySelectorAll('[data-origins-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
